import { AxiosResponse, Canceler } from 'axios';
import settings from '../settings';
import { IApiResult, IPaginationResponseDto, IWriter, IStory, IWriterPermission, IWriterLink, ITransferContractByWriter } from '../types';
import api from './base';

export function searchWriters(keyword: string): [Promise<AxiosResponse<IPaginationResponseDto<IWriter>>>, Canceler] {
  const uri = `${settings.getApiURI()}/writer-admin/v2/search`;

  return api.getWithCancel(uri, {
    params: {
      keyword,
    },
  });
}

export function fetchWriter(writerId: number): [Promise<AxiosResponse<IWriter>>, Canceler] {
  const uri = `${settings.getApiURI()}/writer-admin/v2/writers/${writerId}`;

  return api.getWithCancel(uri);
}

export function updateWriterPermission(writerId: number, permission: Partial<IWriterPermission>): Promise<AxiosResponse<IApiResult<IWriter>>> {
  const uri = `${settings.getApiURI()}/writer-admin/v2/writers/${writerId}`;

  return api.http.patch(uri, { ...permission });
}

export function fetchWriterStories(writerId: number, page = 1, limit = 1000): [Promise<AxiosResponse<IPaginationResponseDto<IStory>>>, Canceler] {
  const uri = `${settings.getApiURI()}/writer-admin/v2/writers/${writerId}/stories`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
    },
  });
}

export function fetchWriterContracts(writerId: number, page = 1, limit = 1000): [Promise<AxiosResponse<ITransferContractByWriter[]>>, Canceler] {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/writers/${writerId}/contracts`;

  return api.getWithCancel(uri, {
    params: {
      page,
      limit,
    },
  });
}

export function deleteEditorFromStory(storyId: number, editorId: number): Promise<AxiosResponse<IApiResult<IStory[]>>> {
  const uri = `${settings.getApiURI()}/story-writer/v3/stories/${storyId}/editors/${editorId}`;

  return api.http.delete(uri);
}

export function fetchWriterTransferLinks(writerId: number): [Promise<AxiosResponse<IWriterLink[]>>, Canceler] {
  const uri = `${settings.getApiURI()}/transfer-admin/v1/writers/${writerId}/writer-links`;

  return api.getWithCancel(uri);
}
